// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MUBWzfUMhgRcTM3KK_No {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}

.ogn91D1Mgvffxh2jXfuc {
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.264px;
  color: rgb(var(--placeholder-primary));
  margin-bottom: 24px;
  }

.bkG00C5Q8WFaSrC5SMJh {
  margin: 20px auto 45px auto;
}

.t0NeZ9ZFYQe2Jmc6vT53,
.NeFn7uERPCavPWrOw8gR {
  text-align: center;
  line-height: 110%;
  letter-spacing: 0.43px;
}

.EodTSSc27as2CWvvBEMk {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-secondary));
  margin-bottom: 12px;
}

._jvsizoqo0SXyXcLj6Q8 {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.RgauO15nhp3Tun5AfSdd {
  font-size: 28px;
  font-style: normal;
  font-weight: 510;
  line-height: 28px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-secondary));
}

.t0NeZ9ZFYQe2Jmc6vT53 {
  display: block;
  font-size: 40px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}

.NeFn7uERPCavPWrOw8gR {
  margin-top: 12px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 122.222% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}

.QqVM2sUzlqOOMj3JRdLH {
  margin: auto 0 10px 0;
  font-size: 17px;
}

.QqVM2sUzlqOOMj3JRdLH:disabled {
  opacity: 1;
  font-weight: 560;
  color: #000000de;
  background: rgba(116, 116, 128, 0.20) !important;
}

.jWk8f2pPhb1f2GrJ_sLe {
  font-size: 16px;
  font-style: normal;
  font-weight: 510;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
  align-self: flex-start;
  text-align: left;
}

.GipEhOC6bsa7rS5ismec {
  border-radius: 28px;
  background: rgba(46, 53, 61, 0.40);
  backdrop-filter: blur(28.950000762939453px);
  -webkit-backdrop-filter: blur(28.9px); 
  padding: 16px;
  
  display: flex;
  flex-direction: column;
}

.xxMnV2YcOvHa4Q7lQpAa {
  width: 100%;
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
}

.pfGearEDUwT5mg_S456A {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pfGearEDUwT5mg_S456A > svg {
  height: 2px;
  width: 100%;
}


.xxMnV2YcOvHa4Q7lQpAa:last-child {
  margin-bottom: 20px;
}

.RbvDAYreNysbjIRXr8ci{
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  color: rgb(var(--placeholder-secondary));
}

.P_FMg29Qs5qZ_JuG9vh0 {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}

/*--------------------password block--------------------*/
  
.pNVsOc1GoRIq_3XyZ6OA {
  margin-bottom: 20px;
}
.m6WtbEhJqXjjSRvmAsLz {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 760;
  line-height: 120%;
}
.biROleQHLTe0mElLRSah {
  padding: 13px;
  font-size: 17px;
  width: 100%;
  border-radius: 10px;
  background: rgba(118, 118, 128, 0.12);
  border: none;
  color: rgba(60, 60, 67, 0.6);
  margin-bottom: 20px;
}

/*--------------------/password block--------------------*/

.oFALmlWD9hHHD8JW12pC {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 17px;
  font-weight: 540;
  color: #FF3B30;
}


._GsfepCICuHXPzvoJvX1 { 
  border-radius: 20px;
  background: rgba(var(--tertiary-bg), 0.30);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  padding: 16px;
  width: 100%;
  border: none;
  outline: none;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: rgb(var(--placeholder-primary));
}`, "",{"version":3,"sources":["webpack://./src/pages/nft-detail/send-nft/checkout/checkot.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;AAEF;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;;EAEb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,yDAAyD;;AAEzD;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;AACxC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.modalTitle {\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.264px;\n  color: rgb(var(--placeholder-primary));\n  margin-bottom: 24px;\n  }\n\n.top {\n  margin: 20px auto 45px auto;\n}\n\n.topAmount,\n.topAmountUsd {\n  text-align: center;\n  line-height: 110%;\n  letter-spacing: 0.43px;\n}\n\n.youSend {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-secondary));\n  margin-bottom: 12px;\n}\n\n.topAmountWrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n}\n\n.topAmountToken {\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 28px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-secondary));\n}\n\n.topAmount {\n  display: block;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.topAmountUsd {\n  margin-top: 12px;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 122.222% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.btn {\n  margin: auto 0 10px 0;\n  font-size: 17px;\n}\n\n.btn:disabled {\n  opacity: 1;\n  font-weight: 560;\n  color: #000000de;\n  background: rgba(116, 116, 128, 0.20) !important;\n}\n\n.detailsHeader {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n  align-self: flex-start;\n  text-align: left;\n}\n\n.info {\n  border-radius: 28px;\n  background: rgba(46, 53, 61, 0.40);\n  backdrop-filter: blur(28.950000762939453px);\n  -webkit-backdrop-filter: blur(28.9px); \n  padding: 16px;\n  \n  display: flex;\n  flex-direction: column;\n}\n\n.infoItem {\n  width: 100%;\n  padding: 16px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n}\n\n.dottedLine {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dottedLine > svg {\n  height: 2px;\n  width: 100%;\n}\n\n\n.infoItem:last-child {\n  margin-bottom: 20px;\n}\n\n.infoItemLeft{\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.07px;\n  color: rgb(var(--placeholder-secondary));\n}\n\n.infoItemRight {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n/*--------------------password block--------------------*/\n  \n.passwordBlock {\n  margin-bottom: 20px;\n}\n.passwordLabel {\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: 760;\n  line-height: 120%;\n}\n.passwordInput {\n  padding: 13px;\n  font-size: 17px;\n  width: 100%;\n  border-radius: 10px;\n  background: rgba(118, 118, 128, 0.12);\n  border: none;\n  color: rgba(60, 60, 67, 0.6);\n  margin-bottom: 20px;\n}\n\n/*--------------------/password block--------------------*/\n\n.alert {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font-size: 17px;\n  font-weight: 540;\n  color: #FF3B30;\n}\n\n\n.messageInput { \n  border-radius: 20px;\n  background: rgba(var(--tertiary-bg), 0.30);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px);\n  padding: 16px;\n  width: 100%;\n  border: none;\n  outline: none;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  color: rgb(var(--placeholder-primary));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MUBWzfUMhgRcTM3KK_No`,
	"modalTitle": `ogn91D1Mgvffxh2jXfuc`,
	"top": `bkG00C5Q8WFaSrC5SMJh`,
	"topAmount": `t0NeZ9ZFYQe2Jmc6vT53`,
	"topAmountUsd": `NeFn7uERPCavPWrOw8gR`,
	"youSend": `EodTSSc27as2CWvvBEMk`,
	"topAmountWrapper": `_jvsizoqo0SXyXcLj6Q8`,
	"topAmountToken": `RgauO15nhp3Tun5AfSdd`,
	"btn": `QqVM2sUzlqOOMj3JRdLH`,
	"detailsHeader": `jWk8f2pPhb1f2GrJ_sLe`,
	"info": `GipEhOC6bsa7rS5ismec`,
	"infoItem": `xxMnV2YcOvHa4Q7lQpAa`,
	"dottedLine": `pfGearEDUwT5mg_S456A`,
	"infoItemLeft": `RbvDAYreNysbjIRXr8ci`,
	"infoItemRight": `P_FMg29Qs5qZ_JuG9vh0`,
	"passwordBlock": `pNVsOc1GoRIq_3XyZ6OA`,
	"passwordLabel": `m6WtbEhJqXjjSRvmAsLz`,
	"passwordInput": `biROleQHLTe0mElLRSah`,
	"alert": `oFALmlWD9hHHD8JW12pC`,
	"messageInput": `_GsfepCICuHXPzvoJvX1`
};
export default ___CSS_LOADER_EXPORT___;
